"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campolongo-maggiore": {
    "04e3f1b2": [{
      "hkey": "ba4bab84",
      "slug": "bojon-santa-maria-assunta",
      "name": "Bojon-Santa Maria Assunta",
      "primary": true,
      "skipSearch": false
    }],
    "bojon": [{
      "hkey": "ba4bab84",
      "slug": "bojon-santa-maria-assunta",
      "name": "Bojon-Santa Maria Assunta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "43b888fd": [{
      "hkey": "ba4bab84",
      "slug": "bojon-santa-maria-assunta",
      "name": "Bojon-Santa Maria Assunta",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-assunta": [{
      "hkey": "ba4bab84",
      "slug": "bojon-santa-maria-assunta",
      "name": "Bojon-Santa Maria Assunta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campolongo-maggiore"
    }]
  }
};
exports["default"] = _default;